import ApiService from '@/services/core/api.service'

const PendingApprovalService = {
  async get (query) {
    return ApiService.get(`user/pending-approvals?${query}`)
  },

  async post (payload) {
    return ApiService.post('user/pending-approvals', payload)
  },

  async put (payload) {
    return ApiService.put(`user/pending-approvals/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`user/pending-approvals/${payload.id}`)
  }
}

export default PendingApprovalService
